// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ChevronLeft = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChevronLeft = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ChevronLeft = _exports.ChevronLeft = function ChevronLeft(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.6931 2.30563C14.1022 2.71313 14.1022 3.37383 13.6931 3.78133L7.44928 10L13.6931 16.2187C14.1022 16.6262 14.1022 17.2869 13.6931 17.6944C13.2839 18.1019 12.6205 18.1019 12.2114 17.6944L5.22678 10.7379C4.81763 10.3303 4.81763 9.66965 5.22678 9.26215L12.2114 2.30563C12.6205 1.89812 13.2839 1.89812 13.6931 2.30563Z",
      fill: "currentColor"
    }));
  };
});
